import React, { JSX } from "react";
import { Close } from "../_icons/Close.tsx";
import styles from "./SystemWarning.module.css";
export const SystemWarning: React.FC<
  React.PropsWithChildren<{
    icon?: JSX.Element;
  }>
> = (props) => {
  const [show, setShow] = React.useState(true);
  if (!show) return null;
  return (
    <div className={styles.SystemWarning}>
      <div className={styles.Icon}>{props.icon}</div>
      <div className={styles.Content}>{props.children}</div>
      <button
        aria-label="Close"
        onClick={() => setShow(false)}
        className={styles.CloseButton}
      >
        <Close />
      </button>
    </div>
  );
};
